<template>
  <section v-loading="loading" class="search-container--filters">
    <LadSearchCustom
      :key="`filters-search`"
      :name="`filters-search`"
      @on-loading="handleLoading"
    />
  </section>
</template>

<script>
export default {
  name: 'LadSearchFilters',
  components: {
    LadSearchCustom: () =>
      import(
        /* webpackChunkName: "lad-search-custom" */ '@/components/search/components/type/custom'
      ),
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    handleLoading(value) {
      this.loading = value
    },
  },
}
</script>

<style lang="scss">
.search-container--filters {
  .before-input i,
  .el-input__inner {
    height: 45px;
    line-height: 45px;
  }
}
</style>
